import { LoginButton } from "@inrupt/solid-ui-react";
import { useState } from "react";
import { Button } from "@mui/material";

const authOptions = {
  clientName: "Solid Commonplace Book",
};

function Login() {
  const [oidcIssuer, setOidcIssuer] = useState("");

  const handleOidcIssuerChange = (event) => {
    setOidcIssuer(event.target.value);
  };

  return (
    <>
      <div className="message">
        <span>
          Connect using:
          <input
            className="oidc-issuer-input "
            type="text"
            name="oidcIssuer"
            list="providers"
            value={oidcIssuer}
            onChange={handleOidcIssuerChange}
          />
          <datalist id="providers">
            <option value="https://login.inrupt.com/" />
            <option value="https://broker.pod.inrupt.com/" />
            <option value="https://inrupt.net/" />
            <option value="https://solidcommunity.net" />
          </datalist>
        </span>
        <Button>
          <LoginButton
            oidcIssuer={oidcIssuer}
            redirectUrl={window.location.href}
            authOptions={authOptions}
          />
        </Button>
        <h5>You are not connected to your personal online dataset. </h5>
      </div>
    </>
  );
}

export default Login;
